import { type PosthogFeatureFlag, UNSET_FEATURE_FLAG } from "@unbox/api";
import { useFeatureFlagEnabled } from "posthog-js/react";
import { useFeatureFlagOverrides } from "@/utils/feature-flag-overrides";
import { RESOLVES_FLAGS_LOCALLY } from "@/utils/feature-flag-source";

// A flag set in the overrides wins; anything not set falls through.
const usePosthogFeatureFlag = (flag: PosthogFeatureFlag): boolean => {
  const isEnabled = useFeatureFlagEnabled(flag);
  return useFeatureFlagOverrides()[flag] ?? isEnabled === true;
};

const useLocalFeatureFlag = (flag: PosthogFeatureFlag): boolean =>
  useFeatureFlagOverrides()[flag] ?? UNSET_FEATURE_FLAG;

export const useFeatureFlag: (flag: PosthogFeatureFlag) => boolean = RESOLVES_FLAGS_LOCALLY
  ? useLocalFeatureFlag
  : usePosthogFeatureFlag;
